import { FormContext, FormSchemaFields } from "@sw-sw/lib-form";
import { UIControlType } from "@sw-sw/lib-form-control-types";
import React, { useContext } from "react";
import FormValidator from "../../utils/FormValidator";
import { ActionButtons } from "../Shared/ActionButtons";
import { Link } from "react-router-dom";
import Logo from "../../images/SW-Logo-White.svg";
import { submitHandler } from "../Shared/form";
import subscriptionApi from "../../utils/api/subscription";

const getSchema = () => {
  const email: "email" = "email"
  const phone: "phone" = "phone"
  const zipcode: "zipcode" = "zipcode"

  return {
    companyName: {
      label: 'Company Name',
      autoComplete: 'freeTrial',
      validation: {
        required: true,
      },
      style: {
        flexBasis: '50%',
      },
    },
    email: {
      label: 'Email',
      autoComplete: 'freeTrial',
      validation: {
        required: true,
        format: email
      },
      style: {
        flexBasis: '50%',
      },
    },

    name: {
      label: 'Name',
      autoComplete: 'freeTrial',
      validation: {
        required: true,
      },
      style: {
        flexBasis: '50%',
      },
    },
    phone: {
      label: 'Phone',
      mask: phone,
      autoComplete: 'freeTrial',
      validation: {
        required: true,
        format: phone
      },
      style: {
        flexBasis: '50%',

      },
    },
    state: {
      label: 'State',
      autoComplete: 'freeTrial',
      validation: {
        required: true,
      },
      style: {
        flexBasis: '33%',
      },
    },
    city: {
      label: 'City',
      autoComplete: 'freeTrial',
      validation: {
        required: true,
      },
      style: {
        flexBasis: '33%',
      },
    },
    zip: {
      label: 'Zip',
      'aria-label': 'zip code',
      className: 'zip',
      autoComplete: 'postal-code',
      maxLength: 5,
      style: { flex: '1 1 33%' },
      validation: {
        format: zipcode,
        maxLength: 5
      },
      inputMode: 'numeric',
      parse: FormValidator.parseNumber,
    },
    industry: {
      label: "Industry",
      controlType: UIControlType.select,
      options: [{ value: 'Construction' }, { value: 'Consultant' }, { value: 'MS4 / Regulatory Agency' }, { value: 'Post-Construction' }],
      labelKey: 'value',
      valueKey: 'value',
      placeholder: "Please select an industry",
      noOptionMessage: "There are no users available.",
      validation: {
        required: true,
      },
      style: {
        flexBasis: '50%',
      },
    },
    noOfProjects: {
      label: 'Estimated Number of Projects',
      autoComplete: 'freeTrial',
      controlType: UIControlType.number,
      validation: {
        required: true,
        maxLength: 5,
      },
      style: {
        flexBasis: '50%',

      },
    },
  };
}

const FirstPage: React.FC = () => {
  const formContext = useContext(FormContext);
  const [submitting, setSubmitting] = React.useState(false);
  let freeTrialUserData = localStorage.getItem('freeTrialUserData')

  const redirectTo = () => {
    switch (formContext.value.industry) {
      case 'MS4 / Regulatory Agency':
        return '/sales-representative';
      case 'Post-Construction':
        return '/sales-representative';
      default:
        return '/subdomain-and-subscription';
    }
  }

  const onSave = async () => {
    if (submitting) return; // Prevent double submission
    
    try {
      setSubmitting(true);
      const res = await subscriptionApi.leadGen(formContext.value);
      
      localStorage.setItem('freeTrialUserData', JSON.stringify({
        ...formContext.value,
        leadGenId: res.data.id
      }));

      const Mainurl = process.env.REACT_APP_FREE_TRIAL_URL;
      window.location.href = `${Mainurl}${redirectTo()}`;
    } catch (error) {
      console.log(error);
      setSubmitting(false);
    }
  };

  
  return (
    <div className="first-page__wrapper">
      <div className="first-page">
        <header>
          <div className="first-page__logo-wrapper">
            <img src={Logo} alt='logo' />
          </div>
          <h3>Already a member? <a href={`${process.env.REACT_APP_LOGIN_URL}/login`}>Login</a></h3>
        </header>
        <div className="first-page__body">
          <div className="first-page__form-box-wrapper">
            <h1>Start Your 30 Day Free Trial!</h1>
            <div className="first-page__form-box">
              <h3 className="first-page__get-started">Get Started!</h3>
              <h3>Account / Organization information</h3>
              <hr />
              <FormSchemaFields
                className="findings-form add-contact-form"
                schema={getSchema()}
                formData={formContext.value}
                onChange={formContext.set}
                initialFormData={freeTrialUserData ? JSON.parse(freeTrialUserData) : {}}
              />
              <div className="first-page__action-buttons">
                <Link to={redirectTo()}>
                  <ActionButtons
                    primary={submitting ? 'Submitting...' : 'Save & Continue'}
                    onClick={(e: React.SyntheticEvent<Element, Event>) => submitHandler(formContext, e, onSave)}
                    primaryDisabled={!formContext.isValid || submitting}
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FirstPage;
